var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpotify(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Bold",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256,512c141.3,0,256-114.7,256-256S397.3,0,256,0S0,114.7,0,256S114.7,512,256,512z M359.9,376.7L359.9,376.7 c-17.2,0-71.6-60.3-224.4-29c-4,1-9.3,2.7-12.3,2.7c-19.5,0-23.3-29.2-2.3-33.7c84.5-18.7,170.9-17,244.6,27.1 C383.2,355,375.7,376.7,359.9,376.7L359.9,376.7z M387.7,309c-2.4-0.6-1.7,1.5-12.7-4.3c-64.5-38.2-160.7-53.6-246.3-30.4 c-4.9,1.3-7.6,2.7-12.3,2.7c-22.8,0-28.9-34.4-4-41.4c100.6-28.3,208.5-11.8,283.7,32.9c8.4,4.9,11.7,11.4,11.7,20.3 C407.6,300,399,309,387.7,309z M97,149.3C193.5,121,339.5,130,430.3,183c23.3,13.4,14.1,47.4-10.6,47.4l0,0c-5.4,0-8.7-1.3-13.3-4 c-73.5-43.9-204.9-54.4-289.9-30.6c-3.7,1-8.4,2.7-13.3,2.7c-13.6,0-24-10.6-24-24.4C79.1,159.9,87.7,152,97,149.3L97,149.3z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotify);
export default __webpack_public_path__ + "static/media/spotify.10a3cb6022d1cb00ce78009fd4238ee1.svg";
export { ForwardRef as ReactComponent };